import { generateClient } from "aws-amplify/api";
import { storeUserScratchPad } from "@/graphql/mutations";
const client = generateClient();
export const UpdateScratchPadText = {
  methods: {
    async UpdateScratchPadTextMethod(scratch_pad_text) {
      try {
        let result = await client.graphql({
          query: storeUserScratchPad,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              scratch_pad_text,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.storeUserScratchPad);
        this.$store.commit("SET_SCRATCHPAD_TEXT", scratch_pad_text);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
        }
      } catch (error) {
        this.noDataText = error.errors[0].message;
        console.log("Error", error);
      }
    },
  },
};
